import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SalesPotentialState } from '../reducers/sales-potential.reducer';

export const selectSalesPotentialState =
  createFeatureSelector<SalesPotentialState>('salesPotential');

export const selectSalesPotentials = createSelector(
  selectSalesPotentialState,
  (state: SalesPotentialState) => state.salesPotentials,
);

export const selectSalesPotentialLoading = createSelector(
  selectSalesPotentialState,
  (state: SalesPotentialState) => state.loading,
);

export const selectSalesPotentialError = createSelector(
  selectSalesPotentialState,
  (state: SalesPotentialState) => state.error,
);
